import { render, staticRenderFns } from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=template&id=b737a638&scoped=true"
import script from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoDestinazioneModalComponent.vue?vue&type=style&index=0&id=b737a638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b737a638",
  null
  
)

export default component.exports